import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import styles from "./TooltipComponent.module.css";
import CommonUtil from "../../utils/CommonUtil";

const TOOL_TIP_OFFSET = 12;

const TooltipComponent = () => {
  const [tooltipText, setTooltipText] = useState("");
  const [tooltipItemClassName, setTooltipItemClassName] = useState("");
  const [tooltipContainerClassName, setTooltipContainerClassName] =
    useState("");
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({
    top: 0,
    left: 0,
  });

  useEffect(() => {
    const viewportWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );
    const handleMouseOver = (event) => {
      const target = event.target;
      const closestTarget = target.closest("[data-tooltip]");
      if (closestTarget) {
        const tooltip = closestTarget.getAttribute("data-tooltip");
        console.log("tooltip", tooltip);
        const tooltipItemClassName = closestTarget.getAttribute(
          "data-tooltip-item-class"
        );
        const tooltipContainerClassName = closestTarget.getAttribute(
          "data-tooltip-container-class"
        );
        closestTarget.addEventListener("click", () => {
          setTooltipVisible(false);
        });
        if (tooltip) {
          setTooltipText(tooltip);
          setTooltipContainerClassName(tooltipContainerClassName ?? "");
          setTooltipItemClassName(tooltipItemClassName ?? "");
          const isRightHalf = event.clientX > viewportWidth / 2;
          setTooltipPosition({
            top: event.clientY,
            left: isRightHalf ? undefined : event.clientX + TOOL_TIP_OFFSET,
            right: isRightHalf
              ? viewportWidth - event.clientX + TOOL_TIP_OFFSET
              : undefined,
          });
          setTooltipVisible(true);
        }
      }
    };

    const handleMouseMove = (event) => {
      if (tooltipVisible) {
        const isRightHalf = event.clientX > viewportWidth / 2;
        setTooltipPosition({
          top: event.clientY,
          left: isRightHalf ? undefined : event.clientX + TOOL_TIP_OFFSET,
          right: isRightHalf
            ? viewportWidth - event.clientX + TOOL_TIP_OFFSET
            : undefined,
        });
      }
    };

    const handleMouseOut = () => {
      setTooltipVisible(false);
    };

    const handleDragStart = (event) => {
      setTooltipVisible(false);
    };

    document.addEventListener("mouseover", handleMouseOver);
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseout", handleMouseOut);
    document.addEventListener("dragstart", handleDragStart);

    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseout", handleMouseOut);
      document.removeEventListener("dragstart", handleDragStart);
    };
  }, [tooltipVisible]);

  // [RENDERS]
  return createPortal(
    <div
      data-component="TooltipComponent"
      className={CommonUtil.groupClass(
        styles["tooltip-component"],
        tooltipContainerClassName
      )}
      style={{
        position: "fixed",
        top: tooltipPosition.top,
        left: tooltipPosition.left,
        bottom: tooltipPosition.bottom,
        right: tooltipPosition.right,
        visibility: tooltipVisible ? "visible" : "hidden",
        opacity: tooltipVisible ? 1 : 0,
        zIndex: 99999999,
      }}
    >
      {tooltipText.split("::").map((tooltip, index) => (
        <p
          key={`${tooltip}-${index}`}
          className={CommonUtil.groupClass(
            styles["tooltip-text"],
            tooltipItemClassName
          )}
        >
          {tooltip}
        </p>
      ))}
    </div>,
    document.body
  ); // No need to render anything in this component
};

export default TooltipComponent;
